import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { Icon } from "@iconify/react";
import { StaffLoginFooterPage } from "./StaffLoginFooterPage/StaffLoginFooterPage";
import { VendorLoginFooterPage } from "./VendorLoginFooterPage/VendorLoginFooterPage";
import { GuestLoginFooterPage } from "./GuestLoginFooterPage/GuestLoginFooterPage";
import { FooterImages } from "./FooterImages/FooterImages";

export const WebFooterImages = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const id = query?.get("id");

  const items = [
    {
      label: "Staff Login Footer Page",
      key: "staffLoginFooterPage",
      children: <StaffLoginFooterPage/>
    },
    {
      label: "Vendor Login Footer Page",
      key: "vendorLoginFooterPage",
      children: <VendorLoginFooterPage/>
    },
    {
      label: "Guest Login Footer Page",
      key: "guestLoginFooterPage",
      children: <GuestLoginFooterPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
